module.exports = __webpack_public_path__ + "static/media/desgaste.fb29c41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driving/desgaste.png
// module id = 739
// module chunks = 0